var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wscn-http404-container",style:({height:_vm.height + 'px'})},[_c('div',{staticClass:"wscn-http404"},[_c('h4',[_vm._v("页面没有找到")]),_c('el-link',{attrs:{"href":"/","type":"primary"}},[_vm._v("返回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }